module.exports = __webpack_public_path__ + "static/media/r.c. worley prayer chapel.fce4ee77.jpeg";